var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 66,
    viewBox: "0 0 76 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4397_41586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3393 42.8078L47.3132 60.8338C44.3007 63.8409 40.2894 65.5 36.0326 65.5C31.7757 65.5 27.7699 63.8409 24.7574 60.8338C22.0941 58.176 20.577 54.8033 20.2004 51.3269C16.6039 50.9394 13.2694 49.3458 10.6825 46.7481C7.65908 43.741 6 39.7352 6 35.4729C6 31.2106 7.65908 27.2048 10.6771 24.1977L28.6977 6.16615C34.9138 -0.0553852 45.032 -0.0553852 51.2535 6.16615C53.9113 8.82941 55.434 12.2021 55.8105 15.6786C59.407 16.0606 62.7415 17.6542 65.3338 20.2519C71.5554 26.4735 71.5554 36.5862 65.3338 42.8132L65.3393 42.8078Z",
    fill: "#121D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2629 17.5L24 23.3266V42.5442L39.2629 48.3708L54.5259 42.5442V23.3266L39.2629 17.5ZM49.2615 24.2849L39.2629 28.1055L29.2644 24.2849L39.2629 20.4644L49.2615 24.2849ZM26.7728 26.2974L37.8829 30.5396V44.8825L26.7728 40.6404V26.2974ZM40.6493 44.8889V30.546L51.7595 26.3038V40.6467L40.6493 44.8889Z",
    fill: "#FFFDFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4397_41586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.5863,
    height: 65.46,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.a43f0535e35e96d1780f02f16fe19764.svg";
export { ForwardRef as ReactComponent };